import moment from 'moment';

export default class DeliveryCutoff {
    constructor() {
        this.getDeliveryInfoUrl = '/checkout/delivery-info';
        this.message = $('[data-delivery-cutoff-message]');
        this.div = $('[data-delivery-cutoff]');
        this.countdown = null;
    }

    setup() {
        $.ajax({
            url: this.getDeliveryInfoUrl
        }).done((data) => {
            if (data === 0) {
                return;
            }
            this.countdown = setInterval(() => {
                this.updateCountdownValue(moment.unix(data), moment());
            }, 1000);
        });
    }

    updateCountdownValue(cutoffMoment, currentMoment) {
        if (cutoffMoment < currentMoment) {
            clearInterval(this.countdown);
            this.div.addClass('hide');
            return;
        }
        let diffMoment = moment(cutoffMoment.diff(currentMoment));
        diffMoment.utc();
        let countdownString = diffMoment.format('H [hours] mm [minutes and] ss [seconds]');
        this.div.removeClass('hide');
        this.message.html(countdownString);
    }
}
